<script>
import ItemIndex from "../../abstract/ItemIndex.js";

export default ItemIndex.extend({
  props: {
    canManage: Boolean
  },
  data() {
    return {
      options: {},
      endpoint: "/api/graduate-profiles",
      default: {},
      messages: {
        remove: {
          title: "Удаление аспирантского профиля",
          message:
            "Вы действительно хотите удалить аспирантский профиль?<br>" +
            "Все группы, связанные с данным профилем будут автоматически удалены.",
          confirm: "Удалить аспирантский профиль",
          cancel: "Отмена",
          success: "Аспирантский профиль был успешно удалён"
        }
      }
    };
  },
  methods: {
    beforeOpen(item) {
      if (!this.canManage) {
        return new Promise((resolve, reject) => {
          reject();
        });
      }

      return new Promise((resolve, reject) => {
        resolve();
      });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/graduate-profiles/Index.vue